export default __webpack_public_path__ + "assets/google-play.0ae06adfcae4d4877863bbeec51073af.svg";